<div checkoutCy="esim_compatibility_modal" class="has-text-left">
    <checkout-cms-block blockId="mixte/modal_e_sim_mobiles_compatibles" [addIndexHtmlToUrl]="false" />
</div>
